import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from './app/core/auth/auth.service';
import { LanguageService } from './app/shared/services/language.service';


@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
    private authService = inject(AuthService);
    private languageService = inject(LanguageService);

    ngOnInit(): void {
        // The LanguageService constructor will handle translation initialization
        console.log('[AppComponent] Initialized with language:', this.languageService.getCurrentLanguage());
        
        // Handle OAuth callback and initialize user profile
    }
}